import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import crmLogoBlack from '../../assets/crm_logo_new_black.svg';
import crmLogoWhite from '../../assets/crm_logo_new_white.svg';

interface LogoProps {
  className?: string;
  showCompanyName?: boolean;
  variant?: 'default' | 'modern' | 'compact';
}

const Logo: React.FC<LogoProps> = ({ 
  className, 
  showCompanyName = false, 
  variant = 'modern' 
}) => {
  const { theme } = useTheme();
  const logoSrc = theme === 'dark' ? crmLogoWhite : crmLogoBlack;
  
  if (variant === 'modern') {
    return (
      <div className="flex flex-col items-center">
        <div className="flex items-center justify-center">
          <img 
            src={logoSrc} 
            alt="YouCRM Logo" 
            className={`${className} transition-all duration-300`} 
          />
        </div>
      </div>
    );
  }
  
  if (variant === 'compact') {
    return (
      <div className="flex items-center space-x-2">
        <img 
          src={logoSrc} 
          alt="YouCRM Logo" 
          className={`${className} max-h-8`} 
        />
      </div>
    );
  }
  
  // Default variant
  return (
    <div className="flex flex-col items-center pt-1">
      <img 
        src={logoSrc} 
        alt="YouCRM Logo" 
        className={className} 
      />
    </div>
  );
};

export default Logo; 